/** The marker cannot authorize a study; deleting it invalidates HttpOnly viewer grants. */
export function clearViewerBinding() {
  document.cookie = 'mohair_viewer_binding=; Max-Age=0; Path=/api/v1; SameSite=Strict';
}
